@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.shipment-details-section-content {
  padding: @space-0 @space-16 @space-24;
}

.shipment-details-section-header {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.multi-address-info {
  color: var(--default--border-color--15);
}
